import { CalendarRange } from "lucide-react";
import { EmptyState } from "@/components/empty-state";
import { Button } from "@/components/ui/button";
import { useFindingsScope } from "./findings-scope-bar";
import { buildScopeLabel, hasBuildScope, periodLabel } from "./scope-url-state";

/**
 * Empty state of a view narrowed by the page scope's period or build
 * (environment, branch, committed only): says which scope came up empty
 * and offers the way back to all time and every build.
 */
export function ScopeEmptyState({ what = "runs" }: { what?: string }) {
  const { scope, setScope } = useFindingsScope();
  const build = hasBuildScope(scope);
  const label = [
    scope.period ? periodLabel(scope.period).toLowerCase() : null,
    buildScopeLabel(scope),
  ]
    .filter(Boolean)
    .join(" · ");
  const widen = [
    scope.period ? "widen the period" : null,
    build ? "include other builds" : null,
  ]
    .filter(Boolean)
    .join(" or ");
  return (
    <EmptyState
      icon={CalendarRange}
      title={
        scope.period ? `No ${what} in this period` : `No ${what} in this scope`
      }
      description={`Nothing matches this scope (${label}). ${widen.charAt(0).toUpperCase()}${widen.slice(1)}.`}
      variant="compact"
      actions={
        <>
          {scope.period && (
            <Button
              variant="outline"
              size="sm"
              onClick={() =>
                setScope({
                  ...scope,
                  period: undefined,
                  periodMode: undefined,
                  tz: undefined,
                })
              }
            >
              Show all time
            </Button>
          )}
          {build && (
            <Button
              variant="outline"
              size="sm"
              onClick={() =>
                setScope({
                  ...scope,
                  environment: undefined,
                  branch: undefined,
                  committedOnly: undefined,
                })
              }
            >
              Show all builds
            </Button>
          )}
        </>
      }
    />
  );
}
